export default {"src":"/_next/static/media/logo.93f639af.svg","height":52,"width":215,"blurWidth":0,"blurHeight":0};